// R10 — the Log a Game card's first line segment. For a regular fixture the
// feed round is shown (`Rd {round}`); for an Origin fixture the segment becomes
// exactly `State of Origin {N} · counts in round {scoringRound}` (or
// `State of Origin {N}` when scoringRound is null), where N is the Roman ordinal
// I/II/III for 1-3 and the number otherwise. The rest of the line (date +
// kick-off) is appended by the caller and is unchanged.
const ROMAN = { 1: "I", 2: "II", 3: "III" };

function originOrdinal(originGame) {
  const n = Number(originGame);
  if (Number.isInteger(n) && n >= 1) {
    return ROMAN[n] ?? String(n);
  }
  return "";
}

export function originLabel(fixture) {
  if (!fixture || !fixture.isOrigin) {
    return `Rd ${fixture?.round ?? ""}`;
  }
  const ordinal = originOrdinal(fixture.originGame);
  const head = ordinal ? `State of Origin ${ordinal}` : "State of Origin";
  if (fixture.scoringRound == null) return head;
  return `${head} · counts in round ${fixture.scoringRound}`;
}

// R11 — the short tag shown beside an Origin fixture inside its scoring
// round's group in the admin queue (the round is already named by the group
// header, so the "counts in round N" tail is not repeated here). Returns null
// for a regular fixture so the caller can skip rendering.
export function originTag(fixture) {
  if (!fixture || !fixture.isOrigin) return null;
  const ordinal = originOrdinal(fixture.originGame);
  return ordinal ? `State of Origin ${ordinal}` : "State of Origin";
}
